function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\n        @import url(\"https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap\");\n\n      .cls-1, .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-1 {\n        fill-opacity: 0.06;\n        stroke: #97c1ff;\n      }\n\n      .cls-1, .cls-4, .cls-5 {\n        stroke-width: 1px;\n        stroke-dasharray: 4 2;\n      }\n\n      .cls-2 {\n        fill: #0f1c3e;\n      }\n\n      .cls-3, .cls-8 {\n        font-family: 'Open Sans';\n        font-size: 12px;\n        text-anchor: middle;\n        text-transform: uppercase;\n      }\n\n      .cls-3 {\n        fill: #f8fbfe;\n      }\n\n      .cls-3, .cls-6, .cls-8 {\n        font-family: SequelSans-BoldBody, \"Sequel Sans\";\n        font-weight: 700;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-4, .cls-5 {\n        stroke: #c9dfff;\n      }\n\n      .cls-5 {\n        fill-opacity: 1;\n      }\n\n      .cls-6 {\n        font-size: 16px;\n        fill: #49596b;\n      }\n\n      .cls-7 {\n        fill: #e4f2ff;\n      }\n\n      .cls-8 {\n        fill: #98c1ff;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 41.469,
  y: 0.313,
  width: 960.531,
  height: 628.093,
  rx: 44,
  ry: 44
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  x: 0.469,
  y: 63.969,
  width: 161.062,
  height: 25,
  rx: 12.5,
  ry: 12.5
});

var _ref5 = /*#__PURE__*/React.createElement("text", {
  fontFamily: "Open Sans",
  id: "How_it_works_",
  "data-name": "How it works?",
  className: "cls-3",
  x: 81.181,
  y: 80.425
}, /*#__PURE__*/React.createElement("tspan", {
  x: 81.181
}, "How it works?"));

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16_copy_4",
  "data-name": "Rectangle 16 copy 4",
  className: "cls-4",
  x: 370.938,
  y: 86.813,
  width: 349.062,
  height: 101.156,
  rx: 9,
  ry: 9
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16_copy_8",
  "data-name": "Rectangle 16 copy 8",
  className: "cls-4",
  x: 236.312,
  y: 222.406,
  width: 349.063,
  height: 101.156,
  rx: 9,
  ry: 9
});

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16_copy_3",
  "data-name": "Rectangle 16 copy 3",
  className: "cls-5",
  x: 262.938,
  y: 23.813,
  width: 349.062,
  height: 101.156,
  rx: 9,
  ry: 9
}), /*#__PURE__*/React.createElement("text", {
  id: "Register_your_account_on_Permanchain_Miner",
  "data-name": "Register your account on Permanchain Miner",
  className: "cls-6",
  x: 294.351,
  y: 66.97
}, "Register your account", /*#__PURE__*/React.createElement("tspan", {
  x: 294.351,
  dy: 23.008
}, "on Permanchain Miner")), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 506,
  y: 47,
  width: 79,
  height: 52,
  rx: 16,
  ry: 16
}));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16_copy_5",
  "data-name": "Rectangle 16 copy 5",
  className: "cls-5",
  x: 541.938,
  y: 149.812,
  width: 349.062,
  height: 101.157,
  rx: 9,
  ry: 9
}), /*#__PURE__*/React.createElement("text", {
  id: "Complete_your_Account_Details",
  "data-name": "Complete your  Account Details",
  className: "cls-6",
  x: 573.35,
  y: 192.97
}, "Complete your ", /*#__PURE__*/React.createElement("tspan", {
  x: 573.35,
  dy: 23.008
}, "Account Details")), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_20_copy",
  "data-name": "Rectangle 20 copy",
  className: "cls-7",
  x: 785,
  y: 173,
  width: 79,
  height: 52,
  rx: 16,
  ry: 16
}));

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16_copy_6",
  "data-name": "Rectangle 16 copy 6",
  className: "cls-4",
  x: 168.938,
  y: 302.812,
  width: 349.062,
  height: 101.157,
  rx: 9,
  ry: 9
});

var _ref11 = /*#__PURE__*/React.createElement("g", {
  id: "Group_18_copy",
  "data-name": "Group 18 copy"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16_copy_3-2",
  "data-name": "Rectangle 16 copy 3",
  className: "cls-5",
  x: 60.938,
  y: 239.812,
  width: 349.063,
  height: 101.157,
  rx: 9,
  ry: 9
}), /*#__PURE__*/React.createElement("text", {
  id: "Deposit_your_funds_to_purchase_mining_equipment",
  "data-name": "Deposit your funds to purchase mining equipment",
  className: "cls-6",
  x: 92.351,
  y: 272.97
}, "Deposit your funds", /*#__PURE__*/React.createElement("tspan", {
  x: 92.351,
  dy: 23.008
}, "to purchase"), /*#__PURE__*/React.createElement("tspan", {
  x: 92.351,
  dy: 23.008
}, "mining equipment")), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: 304,
  y: 263,
  width: 79,
  height: 52,
  rx: 16,
  ry: 16
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  id: "Group_17_copy",
  "data-name": "Group 17 copy"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16_copy_5-2",
  "data-name": "Rectangle 16 copy 5",
  className: "cls-5",
  x: 339.938,
  y: 365.812,
  width: 349.062,
  height: 101.157,
  rx: 9,
  ry: 9
}), /*#__PURE__*/React.createElement("text", {
  id: "Secure_your_power-site_location_to_install_your_mining_hardware",
  "data-name": "Secure your power-site location to install your mining hardware",
  className: "cls-6",
  x: 371.351,
  y: 404.97
}, "Secure your power-site", /*#__PURE__*/React.createElement("tspan", {
  x: 371.351,
  dy: 23.008
}, "location to install your"), /*#__PURE__*/React.createElement("tspan", {
  x: 371.351,
  dy: 23.008
}, "mining hardware")), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_20_copy-2",
  "data-name": "Rectangle 20 copy",
  className: "cls-7",
  x: 583,
  y: 389,
  width: 79,
  height: 52,
  rx: 16,
  ry: 16
}));

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16_copy_7",
  "data-name": "Rectangle 16 copy 7",
  className: "cls-4",
  x: 448.938,
  y: 427.812,
  width: 349.062,
  height: 101.157,
  rx: 9,
  ry: 9
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  id: "Group_17_copy_2",
  "data-name": "Group 17 copy 2"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16_copy_5-3",
  "data-name": "Rectangle 16 copy 5",
  className: "cls-5",
  x: 619.938,
  y: 490.812,
  width: 349.062,
  height: 101.157,
  rx: 9,
  ry: 9
}), /*#__PURE__*/React.createElement("text", {
  id: "Recieve_payouts_directly_to_your_digital_wallet",
  "data-name": "Recieve payouts directly to your  digital wallet",
  className: "cls-6",
  x: 651.351,
  y: 526.971
}, "Recieve payouts", /*#__PURE__*/React.createElement("tspan", {
  x: 651.351,
  dy: 23.008
}, "directly to your "), /*#__PURE__*/React.createElement("tspan", {
  x: 651.351,
  dy: 23.008
}, "digital wallet")), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_20_copy-3",
  "data-name": "Rectangle 20 copy",
  className: "cls-7",
  x: 863,
  y: 514,
  width: 79,
  height: 52,
  rx: 16,
  ry: 16
}));

var _ref15 = /*#__PURE__*/React.createElement("text", {
  id: "_01",
  "data-name": 1,
  className: "cls-8",
  transform: "translate(543.165 84.588) scale(2.775)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0
}, "01"));

var _ref16 = /*#__PURE__*/React.createElement("text", {
  id: "_02",
  "data-name": 2,
  className: "cls-8",
  transform: "translate(824.165 210.588) scale(2.775)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0
}, "02"));

var _ref17 = /*#__PURE__*/React.createElement("text", {
  id: "_03",
  "data-name": 3,
  className: "cls-8",
  transform: "translate(342.165 301.588) scale(2.775)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0
}, "03"));

var _ref18 = /*#__PURE__*/React.createElement("text", {
  id: "_04",
  "data-name": 4,
  className: "cls-8",
  transform: "translate(621.165 428.588) scale(2.775)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0
}, "04"));

var _ref19 = /*#__PURE__*/React.createElement("text", {
  id: "_05",
  "data-name": 5,
  className: "cls-8",
  transform: "translate(902.165 551.588) scale(2.775)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0
}, "05"));

function SvgServicesCmIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1002,
    height: 629,
    viewBox: "0 0 1002 629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesCmIllustration);
export default __webpack_public_path__ + "static/media/services-cm-illustration.9277cbe4.svg";
export { ForwardRef as ReactComponent };